import { Controller } from "@hotwired/stimulus"
import imagesLoaded from "imagesloaded"
import { gsap } from "gsap";

import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin"
import { MotionPathPlugin } from "gsap/MotionPathPlugin"

export default class extends Controller {
  static targets = ["kv", "hangtag", "slogan"]
   static values = {
      show: Boolean, default: true
    }

  connect() {
    this.current = "home"
    gsap.registerPlugin(ScrollToPlugin, DrawSVGPlugin, MotionPathPlugin);

    this.handleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.handleResize);

    if(this.getCookie("tpefw_2026_invitation")){
      this.skip()
    }else{
      this.showValue ? this.setupInitialState() : this.skip()
    }
  } // end connect

  disconnect() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    if(window.innerWidth > 768 && this.current == "hangtag"){
      if (this.hasKvTarget && !this.kvTarget.classList.contains("fade")) {
        gsap.set("#kv", { scrollTo: window.innerHeight });
      }
    }
  } // end handleResize

  setupInitialState(){
    document.querySelector("body").classList.add("hidebar")

    const imgLoad = imagesLoaded(this.element)
    const total = imgLoad.images.length
    let loadedCount = 0
    imgLoad.on('progress', (instance, image) => {
      loadedCount++
      const percent = Math.round((loadedCount / total) * 100)
      this.updateProgress(percent)
    })
  } // setupInitialState

  updateProgress(percent) {
    const self = this
    document.querySelector(".hor-line").style.width = `${percent}%`

    if (percent === 100) {
      setTimeout(function(){
        self.sloganTargets.forEach(text => text.classList.add("show"));
        self.line_animate()
      }, 2000)
    }
  } // updateProgress

  scrollto(e) {
    // 隱藏標語
    this.sloganTargets.forEach(text => text.classList.remove("show"));
    e.target.classList.add("active");

    const kv = this.kvTarget;
    kv.style.zIndex = "1";

    gsap.to(kv, { 
      duration: 1.2, 
      scrollTo: window.innerHeight,
      delay: 1,
      onComplete: () => {
        this.current = "hangtag";
        if(this.hasHangtagTarget) {
          this.hangtagTargets.forEach(el => el.style.display = "block");
          
          const tl = gsap.timeline();
          tl.from(this.hangtagTargets, {
            y: -300,
            rotation: -30,
            opacity: 0,
            duration: 1.2,
            ease: "power4.out",
            stagger: { each: 0.2, from: "random" }
          })
          .to(this.hangtagTargets, {
            rotation: 0,
            duration: 1.5,
            ease: "elastic.out(1, 0.3)" // 調整彈性係數
          }, "-=0.5");
            
          document.querySelector(".h-center-screen")?.classList.add("show");
        }
      }
    });
  }

  // 吊牌擺動
  swingEffect(){
    gsap.to(this.hangtagTargets, {
      rotation: 0,
      startAt: { rotation: 10 },
      duration: 2,
      ease: "elastic.out(1, 0.3)",
      stagger: 0.15
    })
  } // end swingEffect

  line_animate(){
    const items = document.querySelectorAll('.grid-item');

    gsap.to(".mask-rect", {
      attr: { height: 1000 },
      duration: 2,
      ease: "power2.inOut",
      stagger: 0.1
    });

    items.forEach((item, index) => {
      const path = item.querySelector('.move-path');
      const drawLines = item.querySelector('.draw-line');

      const tl = gsap.timeline({ 
        repeatDelay: 1.5,
        delay: 2 + (index * 0.2)
      });

      tl.fromTo(path, 
        { attr: { height: 0 } },
        {
          attr: { height: 1000 },
          duration: 2.5,
          ease: "power1.inOut"
        }
      ).to(drawLines, {
        opacity: 0,
        duration: 1.2,
        delay: 2,
        ease: "power1.inOut"
      });
    });
  } // end line_animate

  line_animate2(){
    document.querySelector(".grid").querySelectorAll(".ver-line").forEach((line, index) => {
      line.style.transitionDelay = (index * 200) + "ms";
      line.classList.add("show")
    })

    const movePaths = gsap.utils.toArray(".move-path");
    const drawLines = gsap.utils.toArray(".draw-line");
    const tracks = gsap.utils.toArray(".track-path");

    movePaths.forEach((path, i) => {
      const track = tracks[i];
      const line = drawLines[i];
      
      const startDelay = i * 0.5;
      gsap
        .timeline()
        .to(path, {
          duration: 3,
          delay: startDelay,
          ease: "none",
          repeat: -1,
          motionPath: {
            path: track,
            align: track,
            alignOrigin: [0.5, 0.5],
            autoRotate: true
          }
        })
        .fromTo(
          line,
          {
            drawSVG: "4% 6%"
          },
          {
            duration: 3,
            ease: "none",
            repeat: -1,
            drawSVG: "94% 96%"
          },
          "<"
        );
    });
  } // end line animate

  skip(){
    window.removeEventListener("resize", this.handleResize);

    document.body.classList.remove("hidebar");
    const header = document.querySelector("#header")
    const sidebar = document.querySelector(".social-sidebar")
    if (header) header.classList.add("show")
    if (sidebar) sidebar.classList.add("show")

    this.kvTarget.classList.add("fade")
    document.querySelector("#home-section").classList.remove("fade")
    document.querySelector("#kv-video").classList.remove("fade")
    setTimeout(() => {
      this.kvTarget.remove()
      const kvVideo = document.getElementById("inside-kv-movie")

      // 首頁 KV 輪播：從影片 slide 開始跑
      const kvSwiper = document.querySelector("#kv-video .swiper")?.swiper
      if (kvSwiper) {
        kvSwiper.slideTo(0, 0)
        kvSwiper.autoplay.start()
      }

      let isMuted = true
      document.getElementById("volumeBtn").addEventListener("click", function(){
        isMuted = !isMuted
        if (kvVideo && kvVideo.contentWindow) {
          kvVideo.contentWindow.postMessage(JSON.stringify({ event: "command", func: isMuted ? "mute" : "unMute", args: [] }), "*")
        }
        document.getElementById("volume-off").classList.toggle("d-none", !isMuted);
        document.getElementById("volume-on").classList.toggle("d-none", isMuted);
      });
    }, 600);
  } // skip

  getCookie(name) {
    let cookieArr = document.cookie.split(";");

    for(let i = 0; i < cookieArr.length; i++) {
      let cookiePair = cookieArr[i].split("=");

      if(name == cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  } //end getcookie
}
